export default __webpack_public_path__ + "static/media/bg-hero-mobile.71b418d4.webp";